import {
  ROUTES,
  ROUTE_POLICIES,
  getAllRequiredPermissions,
  hasAllRequiredPermissions,
} from '@/constants'
import type { CurrentUser } from '@/store'

export function resolveHomeDestination(user: CurrentUser | null): string {
  if (!user) {
    return ROUTES.DASHBOARD
  }

  const roles = new Set([user.role, ...user.roles])

  if (roles.has('admin') || roles.has('superadmin')) {
    return ROUTES.DASHBOARD
  }

  if (roles.has('cashier')) {
    return ROUTES.POS.CHECKOUT
  }

  if (roles.has('operator')) {
    return ROUTES.INVENTORY.LOTS
  }

  const firstPermittedRoute = ROUTE_POLICIES.find((policy) =>
    hasAllRequiredPermissions(user.permissions, getAllRequiredPermissions(policy)),
  )

  return firstPermittedRoute?.path ?? ROUTES.DASHBOARD
}
